import { render, staticRenderFns } from "./SelectPrice.vue?vue&type=template&id=bedd7c62&"
import script from "./SelectPrice.vue?vue&type=script&lang=js&"
export * from "./SelectPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports